const APP_BUILD = {
  buildVersion: import.meta.env.VITE_APP_BUILD_VERSION,
};

export { APP_BUILD };
